.message {
  background: #fff none repeat scroll 0 0;
  border: 0.1rem solid #d9d9d9;
  border-radius: 5px;
  color: #404040;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}

.message-list {
  margin: 0;
}

.message-list > li {
  margin-top: 5px;
  margin-bottom: 5px;
}

.error {
  border: 1px solid #FF6C55;
  background: #FEF2F2;
  color: #7F1D1E;
}

.success {
  border: 1px solid #26BF56;
  background: #ECFDF5;
  color: #0E4E3B;
}

.warning {
  border-color: #d6bd5c;
  background: #fdeeb4;
  color: #6c5a13;
}
